import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { UserService } from '@app-services/user/user.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SignupService } from '@app-services/signup/signup.service';
import { VerifyOtpDialogComponent } from '../verify-otp-dialog/verify-otp-dialog.component';
import { TenantConstant } from '@app-constants/tenant.constant';
import { constructLSQReqBody, makeLSQReq } from '../testseries-dialog/testseries-dialog.component';
@Component({
  selector: 'app-neet-live-class-dialog',
  templateUrl: './neet-live-class-dialog.component.html',
  styleUrls: ['./neet-live-class-dialog.component.css']
})
export class NeetLiveClassDialogComponent implements OnInit {
  grades: any = [];
  exams: any = [];
  streams: any = [];
  tenant: any = TenantConstant.tenant;
  public neetForm: any = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    grade: 11,
    whatsappConsent: true
  }
  heading: string;
  @ViewChild('neetlive') public neetlive: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public SignupService: SignupService,
    private dialogRef: MatDialogRef<NeetLiveClassDialogComponent>,
    private gAnalytics: GAnalyticsService,
    private gradesService: BoardsService,
    private userService: UserService,
    public router: Router,
    private dialog: MatDialog,
    private gaService: GAnalyticsService
  ) {
  }

  ngOnInit(): void {
    if (this.tenant != 'srichaitanya') {
      this.gradesService.getGrades(this);
      this.gradesService.getTargetExams(this);
      this.gradesService.getStreams(this);
    }
    if (this.data.mod == 'ts') {
      this.heading =  "Register Now for ILTS Test Series"
    } else if(this.data.mod == 'lc') {
      this.heading = "Register Now for Neet Live classes"
    } 
  }

  next(): void {
    if (!this.neetForm.firstname && !this.neetForm.lastname) {
      alert("please enter a valid name");
      return;
    }
    if (!(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.neetForm.email))) {
      alert("please enter a valid email address");
      return;
    }
    if (!(/^[6-9][0-9]{9}$/.test(this.neetForm.phone))) {
      alert("please enter a valid mobile number");
      return;
    }
    if (this.tenant != 'srichaitanya') {
      let body = {
        firstName: this.neetForm.firstname,
        lastName: this.neetForm.lastname,
        phone: this.neetForm.phone,
        whatsappConsent: this.neetForm.whatsappConsent,
      }
      this.register(body, "+91")
    } else {
      this.neetformSubmit({});
    }
  }

  register(formValue: any, countryCode: string): any {
    this.SignupService.generateOtp(formValue, countryCode).subscribe((data: any) => {
      if (data) {
        this.gAnalytics.sendEvent('formSubmit', 'signup_data', 'signup_data',
          'signup/login', formValue)
        this.dialogRef.close();
        this.openOTPVerificationPopup();
      } else { this.neetForm['phone'] = ''; }
    },
      (error) => {                                     // on error
        this.neetForm['phone'] = '';
        if (error.error && error.error.message) {
          alert(error.error.message);
        } else {
          alert("Server error");
        }
      });
  }

  openOTPVerificationPopup(): void {
    const formVal = this.neetForm;
    const config: MatDialogConfig = {
      width: '450px',
      data: {
        message: 'Verify OTP',
        message2: `Please verify the OTP sent to +91 ${formVal.phone} `,
        totalData: formVal,
        countryCode: "+91",
        phone: formVal.phone,
        actionData: {},
        isFormSubmit: true,
      },
      autoFocus: true
    };

    const dialogRef = this.dialog.open(VerifyOtpDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.neetformSubmit(value)
      }
    });
  }


  keyEscape(event: any) {
    // console.log(event)
    if (event.key === 'Escape') {
      this.dialogRef.close();
    }

    if (event.keyCode === 13) {
      document.getElementById('AgreeTerms')?.focus()
    }
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }
  selectGrade(grade: number) {
    this.neetForm.grade = grade;
  }
  neetformSubmit(value: any) {
    
    makeLSQReq.call(this, {value, reset:() => {this.neetlive.reset();},  formVal: this.neetForm, ex1: "NEET", ex2: "NEET",  streamName: "PCB", source: this.data.mod == 'ts' ? 'NEET page ts_start' : this.data.mod == 'lc' ? 'NEET page lc_start' : 'NEET page Reg_btn', cb: (waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment) => {this.navigateToDashboard(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment, this.neetForm);}});
  }

  navigateToDashboard(waitForUserDataUpdate: any, userDataUpdated: any, leadCreated: any, needPayment: any, formVal: any ) {
      if((!waitForUserDataUpdate || userDataUpdated) && leadCreated) {
        let user = JSON.parse(localStorage.getItem('mobile_and_name'));
            this.gaService.sendEvent(
              'Register for live class',
              '',
              '',
              '',
              {
                'event': 'Register for live class',
                'First Name': user.firstName,
                'Last Name': user.lastName,
                'Phone Number': user.phone,
                'Navigated to which page': this.router.url,
                'Grade': user.grade,
              }
            )
        if (this.tenant != 'srichaitanya') {
          localStorage.setItem("targetExamName", "NEET");
          localStorage.setItem('SelectedTab', this?.data?.mod == 'ts' ?  'assessment': 'liveclass');
        
          const navExtras = { ...(this.data || {}), ...formVal, detailsEntered: true };
          const navigationExtras: NavigationExtras = {
            state: navExtras 
          };
          
          if(needPayment) {
            
            this.dialogRef.close();
            this.router.navigate(['/paynow'], navigationExtras).then(() => {
              //this.spinner.hide();
            });
          } else {
            this.dialogRef.close();
            this.router.navigate(['/thankyou'], navigationExtras).then(() => {
              //this.spinner.hide()
            });
          }
        }
        
      }
  }

  limitnumbertoten(event: any) {
    if (event.target.value.length > 9) {
      event.target.value = event.target.value.slice(0, 9)
    }
  }
}
